import axios from 'axios';
import { useCallback, useEffect } from 'react';

// Define a custom hook that fetches data and dispatches action
const useFetchAndDispatch = (requestType, url, actionType, dispatch) => {
  // Memoize the fetchData function with useCallback
  const fetchData = useCallback(async () => {
    // Make a request with axios.request()
    const response = await axios.request({
      method: requestType, // Pass the requestType as the method
      url: url // Pass the url as the url
      // Optionally, pass any other options here
    });
    // Dispatch the action with the data
    dispatch({
      type: actionType,
      payload: response.data.data
    });
    //console.table(`${response.data}`);
    // Return the data
    return response.data.data;
  }, [requestType, url, dispatch, actionType]);

  // Call the fetchData function with useEffect
  useEffect(() => {
    fetchData();
  }, [fetchData]);
};

// Export the useFetchAndDispatch hook as a default export
export default useFetchAndDispatch;
